// @flow
import React from 'react';
import { LevelBarWrapper } from '../../partials';

type Props = {
  riskProfile: number
};

export function BarRiskProfile({ riskProfile }: Props) {
  return (
    <LevelBarWrapper risk={riskProfile}>
      <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M11 20.5C16.2467 20.5 20.5 16.2467 20.5 11C20.5 5.75329 16.2467 1.5 11 1.5C5.75329 1.5 1.5 5.75329 1.5 11C1.5 16.2467 5.75329 20.5 11 20.5Z"
          stroke="white"
          strokeWidth="3"
        />
      </svg>
      <svg width="323" height="22" viewBox="0 0 323 22" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect x="323" y="3" width="16" height="320" rx="7.99999" transform="rotate(90 323 3)" fill="#86D497" />
        <rect
          x="323"
          y="3"
          width="16"
          height="320"
          rx="7.99999"
          transform="rotate(90 323 3)"
          fill="url(#paint0_linear)"
        />
        <rect
          x="323"
          y="3"
          width="16"
          height="320"
          rx="7.99999"
          transform="rotate(90 323 3)"
          fill="url(#paint1_linear)"
        />
        <rect
          x="323"
          y="3"
          width="16"
          height="320"
          rx="7.99999"
          transform="rotate(90 323 3)"
          fill="url(#paint2_linear)"
        />
        <rect
          x="323"
          y="3"
          width="16"
          height="320"
          rx="7.99999"
          transform="rotate(90 323 3)"
          fill="url(#paint3_linear)"
        />
        <defs>
          <linearGradient id="paint0_linear" x1="331" y1="3" x2="331" y2="323" gradientUnits="userSpaceOnUse">
            <stop offset="0.9999" stopColor="#1D8614" />
            <stop offset="1" stopColor="white" stopOpacity="0" />
          </linearGradient>
          <linearGradient id="paint1_linear" x1="331" y1="3" x2="331" y2="323" gradientUnits="userSpaceOnUse">
            <stop stopColor="white" />
            <stop offset="0.734375" stopColor="#FFFD38" stopOpacity="0.459579" />
            <stop offset="1" stopColor="white" stopOpacity="0" />
          </linearGradient>
          <linearGradient id="paint2_linear" x1="331" y1="3" x2="331" y2="323" gradientUnits="userSpaceOnUse">
            <stop offset="0.244792" stopColor="#FFAF38" />
            <stop offset="1" stopColor="white" stopOpacity="0" />
          </linearGradient>
          <linearGradient id="paint3_linear" x1="331" y1="3" x2="331" y2="323" gradientUnits="userSpaceOnUse">
            <stop offset="0.119792" stopColor="#FC1A1D" />
            <stop offset="0.598958" stopColor="white" stopOpacity="0" />
          </linearGradient>
        </defs>
      </svg>
    </LevelBarWrapper>
  );
}
